import React from 'react'

const TopArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1.0em" height="0.8em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 15l7-7l7 7"/></svg>
  )
}

export default TopArrow
